'use client';
import Image from 'next/image';
import React from 'react';

interface Logos {
  directus_files_id: {
    id: string;
    title: string;
  };
}

const TrustedBrands = ({
  title,
  title_color,
  logos,
}: {
  title: string;
  title_color: string;
  logos: Logos[];
}) => {
  if (!logos?.length) return null;

  return (
    <div className="flex flex-col relative z-10 bg-white items-center py-[32px] px-4 md:px-0 md:py-[48px] gap-[24px] w-full">
      <p
        style={{ color: title_color || '#0d0d12' }}
        className="text-[16px] md:text-[18px] text-center font-proxima_font font-bold text-black"
      >
        {title}
      </p>
      <div className="grid grid-cols-12 justify-items-center">
        <div className="col-[2/-2]">
          <div className="grid grid-cols-3 gap-y-2 gap-x-4 sm:gap-x-14 sm:gap-y-5 h-auto sm:flex sm:items-center sm:justify-center flex-wrap w-full ">
            {logos?.map((logo, index) => (
              <Image
                key={index}
                src={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/${logo?.directus_files_id?.id}`}
                alt={logo?.directus_files_id?.title}
                title={logo?.directus_files_id?.title}
                height={200}
                width={200}
                sizes="(max-width: 768px) 100px, 150px"
                className="w-auto object-contain h-[32px] md:h-[40px]"
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustedBrands;
